import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { USER_ID_DEV } from '../../../mock/user';
import { TokenPropertyService } from '../token-property.service';

export type UserPreference = {
  dashboardId: string,
  sheetId?: string,
  visualId?: string,
  likeInd?: string,
  dislikeInd?: string,
  pinInd?: string,
  contentId: string,
}
@Injectable({
  providedIn: 'root'
})
export class PreferencesService {
  private API_URL: string;
  private token: any;
  private tokenDetails: any;
  private userId: string = USER_ID_DEV;
  private idToken: any;

  constructor(
    private http: HttpClient,
    @Inject('API_URL') apiUrl: string,
    private tokenPropertyService: TokenPropertyService
  ) {
    this.API_URL = apiUrl;
    this.token = localStorage.getItem('token');
    this.idToken = localStorage.getItem('id_token');
    this.userId = this.tokenPropertyService.getPropertyFromToken('sub', 'token') || USER_ID_DEV;
  }

  setPreferences({ dashboardId, sheetId, visualId, likeInd, dislikeInd, pinInd, contentId }: UserPreference): Observable<any> {
    const headers = new HttpHeaders().set('Authorization', `${this.token}`).set('id_token', `${this.idToken}`);
    return this.http.post<any>(`${this.API_URL}/user/preferences`,
      {
        dashboardId,
        sheetId,
        visualId,
        likeInd,
        dislikeInd,
        pinInd,
        contentId
      }, { headers })
  }
}
